import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';

import { Observable } from 'rxjs';
import { HTTPOPTIONS } from '../../common/constants';
import { map, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MonitoreoService {

  private monitoreoUrl = `${environment.apiBaseUrl}/monitoreo`;

  constructor(public http: HttpClient) {   }


  public getAccesomoniteo(): Observable<any> {
    return this.http.post<any>(`${this.monitoreoUrl}`, HTTPOPTIONS)
      .pipe(
        map((resp: any) => resp),
        catchError((err: HttpErrorResponse) => {
          return Observable.throw(err);
        })
    );
  }

}
